export default __webpack_public_path__ + "static/media/anoutus (2).ba4c0d55.jpg";